import React from "react";

const HomeFeatures = ({ beds, baths, cars, livingRooms }) => {
    return (
        <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-2 w-[calc(50%-0.5rem)] sm:w-auto">
                <span className="w-8 h-8 flex items-center justify-center bg-gableGreen text-white rounded-full font-mori font-medium">
                    {beds}
                </span>
                <span className="font-mori text-gableGreen">Beds</span>
            </div>
            <div className="flex items-center gap-2 w-[calc(50%-0.5rem)] sm:w-auto">
                <span className="w-8 h-8 flex items-center justify-center bg-gableGreen text-white rounded-full font-mori font-medium">
                    {baths}
                </span>
                <span className="font-mori text-gableGreen">Baths</span>
            </div>
            <div className="flex items-center gap-2 w-[calc(50%-0.5rem)] sm:w-auto">
                <span className="w-8 h-8 flex items-center justify-center bg-gableGreen text-white rounded-full font-mori font-medium">
                    {cars}
                </span>
                <span className="font-mori text-gableGreen">Cars</span>
            </div>
            {livingRooms && (
                <div className="flex items-center gap-2 w-[calc(50%-0.5rem)] sm:w-auto">
                    <span className="w-8 h-8 flex items-center justify-center bg-gableGreen text-white rounded-full font-mori font-medium">
                        {livingRooms}
                    </span>
                    <span className="font-mori text-gableGreen">
                        Living Spaces
                    </span>
                </div>
            )}
        </div>
    );
};

export default HomeFeatures;
